module.exports = __webpack_public_path__ + "c8259926fa3120b336565a4bb34b0249.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/galeriaFotos/021.jpg
// module id = 12
// module chunks = 0